export default [
    {
        /** 退出系统 */
        name: 'areaLists',
        url: '/lists'
    }
];
